export const CONSENSUS_OPTION_LABEL = "All platforms - consensus view";
